import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { AuthorizedDataNode } from '@app/services/api/api.types';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedDataService {
  protected authorizedData$ = new BehaviorSubject<Partial<AuthorizedDataNode> | null>(null);

  public refetchAuthorizedData$ = new Subject<void>();

  refetchAuthorizedDataEvent() {
    this.refetchAuthorizedData$.next();
  }

  getAuthorizedData(): Observable<Partial<AuthorizedDataNode> | null> {
    return this.authorizedData$.asObservable();
  }

  getAuthorizedDataValue(): Partial<AuthorizedDataNode> | null {
    return this.authorizedData$.value;
  }

  patchAuthorizedData(authorizedData: Partial<AuthorizedDataNode>) {
    this.authorizedData$.next({ ...this.getAuthorizedDataValue(), ...authorizedData });
  }
}
